//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      form:{
        pageIndex:1,
        pageSize:10
      },
      applyVisible:false,
      timeNow:'',
      editList:[],
      extendList:[],
      apllyInfo:'',
      oprate:'',
      timecha:'',
      waitInfoData: '',
      waitss:'',
      waits:'',
      yancVisible:false,
      yancInfo:'',
      payOrder:'',
      handleForm: {
        opinionType: '1',
        projectPlanEndTime: '',
        tipAmount: ''
      },
      extendVisible:false,
      opinionReason:'',
      rows:'',
      userId:''
    };
  },
  created(){
    
  },
  mounted() {
    this.timeNow = new Date().getHours()
    if (this.tickers) {
      clearInterval(this.tickers);
    }
    this.getReresh()
    this.aduitInfo()
    this.userId = getSession('user').id
  },
  methods: {

    aduitInfo(){
      this.applyInfo()
      this.extendInfo()
    },

    // 查看取消的待办
    waitInfos(id) {
      this.$get('/activiti/act/audit/wait?userId=' + getSession('user').id+'&businessKey='+id, function(res){
        if (res.code == 200) {
          this.waitInfoData = res.data;
          if (res.data) {
            this.waits = res.data.taskName;
            this.waitss = 1
          } else {
            this.waits = '';
            this.waitss = 0
          }
        }
      })
    },
    
    // 申请编辑列表
    applyInfo(){
      this.$get('/tra/project/modify/list?traProjectId='+this.$route.query.id,function(res){
        if(res.code==200){
          this.editList= res.data
        }
      })
    },

    //查看编辑详情
    lookApply(id){
      this.waitInfos(id);
      this.applyVisible= true
      this.$get('/tra/project/modify?id='+id,function(res){
        if(res.code==200){
          this.apllyInfo = res.data;
            var userId = getSession('user').id;
            var opinionList = res.data.opinionList;
            for (var i = 0; i < opinionList.length; i++) {
              if (opinionList[i].userId == userId) {
                this.handleForm = opinionList[i]
              }
            }
        }
      })
    },

    sentHandleForm(){
      if (!this.handleForm.opinionType) {
        this.$message.error('请选择意见');
        return;
      }
      if (this.handleForm.opinionType == 2) {
        if (!this.handleForm.tipAmount) {
          this.$message.error('请填写支付金额');
          return;
        }
      }
      if (this.handleForm.opinionType == 3) {
        if (!this.handleForm.projectPlanEndTime) {
          this.$message.error('请选择日期');
          return;
        }
      }
      if (this.handleForm.opinionType == 4) {
        if (!this.handleForm.tipAmount) {
          this.$message.error('请填写支付金额');
          return;
        }
        if (!this.handleForm.projectPlanEndTime) {
          this.$message.error('请选择日期');
          return;
        }
      }
      if (this.handleForm.opinionType == 5) {
        this.handleForm.isAgree = false;
        this.waitInfoData.opinion = '2';
      } else {
        this.handleForm.isAgree = true;
        this.waitInfoData.opinion = '2';
      }
      this.$post('/tra/project/modify/opinion', this.handleForm, function(res){
        if (res.code == 200) {
          this.$message.success('操作成功!')
          this.applyVisible = false;
          this.auditPass(this.waitInfoData);
        }
      },true)
    },

      
    // 是否通过审核,审批流程
    auditPass(auditPassInfo) {
      this.$post('/activiti/act/audit/pass', auditPassInfo, function(res){
        if (res.code == 200) {
          this.$parent.projectXn()
          this.applyInfo()
        } else {
          this.$message.error(res.msg);
        }
      },true)
    },

    //延长保障期列表
    extendInfo(){
      this.$get('/tra/project/ensure/extend/list?traProjectId='+this.$route.query.id,function(res){
        if(res.code==200){
          this.extendList= res.data
        }
      })
    },

    // 查看详情(延长申请列表)
    lookInfo(id){
      this.yancVisible= true
      this.$get('/tra/project/ensure/extend/detail?id='+id, function(res){
        if (res.code == 200) {
          this.yancInfo = res.data;
        }
      })
    },

      // 同意延长
      agreeExtend(rows){
        this.$confirm('确定同意吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          rows.isAgree = 1;
          this.$post('/tra/project/ensure/extend/approve', rows, function(res){
            if (res.code == 200) {
              this.$message.success('确认同意!');
              this.yancVisible = false;
              this.extendInfo();
            }
          },true)

        })
      },
      // 拒绝延长
      refuseExtend(rows){
        this.rows=rows;
        this.opinionReason=''
        this.extendVisible = true;
      },

      submitRefuseExtend(){
        if(!this.opinionReason){
          this.$message.error('请填写拒绝原因');
          return
        }
        var rows = this.rows;
        rows.isAgree=2;
        rows.opinionReason= this.opinionReason;
        this.$post('/tra/project/ensure/extend/approve', rows,function(res){
          if (res.code == 200) {
            this.$message.success('确认拒绝!');
            this.yancVisible = false;
            this.extendVisible= false;
            this.extendInfo();
          }
        },true)
      },

    // 拨打电话
    callTel(phone){
      const a = document.createElement("a");
      a.href = "tel:"+phone+""
      a.click();
    },

    // 联系专家
    linkPerson(row){
      this.rowid = row.id
      this.getIsExtract()
      this.personVisible= true
    },
    // 中标专家列表
    getIsExtract(){
      let params = { projectId: this.$route.query.id }
        this.$get('/tra/project/bid/meetingList', params,function(res){
          if(res.code==200){
            var list = res.data
            this.extractUserList = list
            this.autoStart()
          }
        })
    },

    getReresh(){
      this.tickers = setInterval(() => {
        if(this.$route.path.indexOf('/outsourcer/underProMeetInfo')!=-1){
          if(this.personVisible==true){
            //需要定时执行的代码
            this.getIsExtract()
          }else{
            clearInterval(this.tickers)
            this.tickers=''
          }
        }else{
          clearInterval(this.tickers)
          this.tickers=''
        }
      },10000)
    },


  },
};
